import { render } from "./appTabs.vue?vue&type=template&id=707fdbd1&scoped=true"
import script from "./appTabs.vue?vue&type=script&lang=js"
export * from "./appTabs.vue?vue&type=script&lang=js"

import "./appTabs.vue?vue&type=style&index=0&id=707fdbd1&scoped=true&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707fdbd1"]])

export default __exports__